import React from "react";
import { useParams } from "react-router-dom";
import { Container, Paper, Typography, useTheme } from "@mui/material";
import ResetPasswordForm from "../forms/ResetPasswordForm";

const ResetPasswordPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const theme = useTheme();

  return (
    <Container
      maxWidth="sm"
      sx={{ py: 10, display: "flex", justifyContent: "center" }}
    >
      <Paper
        elevation={24}
        sx={{
          p: 5,
          borderRadius: theme.appRadius.xl,
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
          Set New Password
        </Typography>
        <ResetPasswordForm token={token!} />
      </Paper>
    </Container>
  );
};
export default ResetPasswordPage;
